import { computed, inject, Injectable, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationsComponent } from './notifications.component';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService as MessageService } from './notification.service';
import { NotificationHandlerService } from './notification-handler.service';
import { NotificationsService } from './notifications.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsModalService {
  readonly notificationHandlerService = inject(NotificationHandlerService);
  readonly notificationsService = inject(NotificationsService);
  readonly opened = signal(false);
  protected readonly soundPlayer = computed(() => {
    const el = document.createElement('audio');
    el.src = `assets/audio/notification.wav`;
    return el;
  });
  constructor(
    public mS: MessageService,
    public dialog: MatDialog,
  ) {
    // this.mS.newNotification$.subscribe((r) => {
    //   this.mS.uS.toast.add({
    //     body: r._body,
    //     tag: 2,
    //     header: r._title ?? `New notification`,
    //     expansionHandler: () => {
    //       this.notificationsService.markAsUnread(r);
    //       if (!this.notificationHandlerService.handleNotificationOpen(r)) this.open();
    //     },
    //   });
    //   this.soundPlayer().play();
    // });
  }

  protected openModalSub!: Subscription;
  open() {
    this.opened.set(true);
    this.openModalSub?.unsubscribe();
    this.openModalSub = this.dialog
      .open(NotificationsComponent, {
        width: '450px',
        position: { right: '-10px', top: '80px', bottom: '50px' },
        height: '100vh',
        hasBackdrop: true,
        panelClass: 'notifications-modal',
      })
      .afterClosed()
      .subscribe(() => {
        this.opened.set(false);
      });
  }
}
